import React from 'react';
import { ReactComponent as SpinnerIcon} from '../assets/icons/spinner.svg';

export default ({ message, width = 215 }) => (
  <div
    style={{
      width:'15rem',
      position: 'fixed',
      textAlign: 'center',
      transform: 'translateX(-50%)',
      zIndex: 20,
      left: '50%',
      bottom: '45%',
      padding: '7px 18px',
      boxShadow: '0 0 6px 0 rgba(167,167,167,0.5)',
      background: 'white',
        border:'1px solid #eee'
    }}
  >
    <span
      style={{
        color: 'var(--theme-text-color)',
        fontSize: '14px',
        position: 'relative',
        top: -3,
      }}
    >
      <SpinnerIcon
        style={{
          position: 'relative',
          top: 7,
        }}
      />
      {message}
    </span>
  </div>
);
